import { useTranslation } from 'react-i18next';
import {
  AppWindow,
  Calculator,
  CookingPot,
  DoorOpen,
  Footprints,
  Gamepad2,
  Grid2x2,
  LogIn,
  RectangleHorizontal,
  Shapes,
  ShowerHead,
  Type,
  Wine,
  type LucideIcon,
} from 'lucide-react';
import { MapElementType } from '@/lib/shared-types';
import { MAP_ELEMENT_TYPES, elementFill } from '../lib/scene';

const ICONS: Record<MapElementType, LucideIcon> = {
  TABLE: Grid2x2,
  RESOURCE: Gamepad2,
  WALL: RectangleHorizontal,
  DOOR: DoorOpen,
  WINDOW: AppWindow,
  BAR: Wine,
  KITCHEN: CookingPot,
  CASHIER: Calculator,
  BATHROOM: ShowerHead,
  ENTRANCE: LogIn,
  STAIRS: Footprints,
  TEXT: Type,
  CUSTOM: Shapes,
};

/** §5.2 — the full `MapElementType` palette; a click drops one in the middle of the view. */
export function MapPalette({ onAdd }: { onAdd: (type: MapElementType) => void }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-1.5">
      {MAP_ELEMENT_TYPES.map((type) => {
        const Icon = ICONS[type];
        return (
          <button
            key={type}
            type="button"
            onClick={() => onAdd(type)}
            className="flex items-center gap-2 rounded-lg border px-2 py-2 text-start text-xs hover:bg-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <span
              className="grid h-6 w-6 shrink-0 place-items-center rounded"
              style={{ background: elementFill[type] }}
              aria-hidden
            >
              <Icon className="h-3.5 w-3.5" />
            </span>
            <span className="truncate">{t(`spaces.element.${type}`)}</span>
          </button>
        );
      })}
    </div>
  );
}
